'use client';
import { ForwardedRef, InputHTMLAttributes, forwardRef } from 'react';

export const Input = forwardRef(function SearchInput(
  props: InputHTMLAttributes<HTMLInputElement>,
  ref: ForwardedRef<HTMLInputElement>,
) {
  return <input ref={ref} {...props} />;
});
